// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__cwCD2","label":"style_label__XsM-3","actions":"style_actions__yl9Ll","actions_btn":"style_actions_btn__InEXb"};